import { Link } from '@tanstack/react-router';
import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { GetHomeTabSuggestionsResponse } from '@/../../server/types/apiTypes';
import downArrow from '@/assets/down_arrow.svg';
import { HomeTabSuggestionItem } from '../../../../shared/types/socialTypes';
import SuggestionItem from './SuggestionItem';

const HomeTabSuggestions = () => {
  const { data } = useQuery({
    queryKey: ['homeTabSuggestions'],
    queryFn: async () => {
      const response = await axios.get<GetHomeTabSuggestionsResponse>('/api/social/getHomeTabSuggestions');
      if (response.data.success) {
        return response.data.data;
      }
      return [];
    },
  });

  return (
    <div className="flex flex-col items-center">
      <div className="flex gap-2 items-center">
        <p className="text-md font-bold text-white">Ask your connections directly</p>
        <img src={downArrow} alt="down arrow" />
      </div>
      <div className="flex flex-col gap-2 mt-8">
        {data?.map((suggestion: HomeTabSuggestionItem) => (
          <SuggestionItem key={suggestion.entityId} suggestion={suggestion} />
        ))}
      </div>
      <Link
        to="/connections"
        className="text-sm cursor-pointer underline"
        style={{ marginTop: '16px', color: 'white' }}
      >
        See more connections {'>'}
      </Link>
    </div>
  );
};

export default HomeTabSuggestions;
